import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useEJLogContext } from '../../../../EJLogContext'
import { EngineeringJudgement } from '../../../../EJLogContext/types'
import { CommonEJFormItemsValues } from '../../components/CommonEJFormItems/types'

export function useEdit(): EditRowActionOptions<
  EngineeringJudgement,
  CommonEJFormItemsValues
> {
  const {
    editModal: { toggle },
  } = useEJLogContext()
  return {
    permission: Permission.EditEngineeringJudgement,
    modal: { type: 'custom', toggle },
  }
}
